import useIdsGaTracking from '@ids/hooks/useIdsGaTracking';

const useCTAButtonTracking = () => {
    const { trackIdsEvent } = useIdsGaTracking();

    const trackButtonClick = (label: string) => {
        trackIdsEvent({
            action: 'CTA button click',
            label,
        });
    };

    return trackButtonClick;
};

export { useCTAButtonTracking };
